import { adTechLog } from "./log";

/**
 * Set the func data for later use.
 *
 * @param {string} type
 * @param {string} id
 * @param {mixed} func
 * @param {Number} sectionIndex
 */
export const addNewAdSlotDefineFunc = ( type, id, func, sectionIndex ) => {

	// Bail early if the func was not found.
	if ( 'undefined' === typeof type ||
		'undefined' === typeof id ||
		'undefined' === typeof func ) {
		return undefined;
	}

	// Create the base object if it hasn't been created yet.
	if ( 'undefined' === typeof window.adTech[ type ] ) {
		window.adTech[ type ] = {
			slotDefineFunctions: {}
		};
	}

	// Create the object for the slotDefineFunctions to reside.
	if ( 'undefined' === typeof window.adTech[ type ].slotDefineFunctions ) {
		window.adTech[ type ].slotDefineFunctions = {};
	}

	const index = Object.keys( window.adTech[ type ].slotDefineFunctions ).length;

	window.adTech[ type ].slotDefineFunctions[ id ] = {
		sectionIndex,
		type,
		index,
		id,
		func,
	};
}

/**
 * Set the slot data for later use.
 *
 * @param {string} type
 * @param {string} id
 * @param {mixed} slot
 * @param {Number} sectionIndex
 */
export const addNewAdSlot = ( type, id, slot, sectionIndex ) => {

	// TODO delete test code for forcing ads to delay storage causing race conditions.
	// setTimeout( () => {

	// Bail early if the slot data is not available.
	if ( 'undefined' === typeof type ||
		'undefined' === typeof id ||
		'undefined' === typeof slot ) {

		return;
	}

	// Create the base object if it hasn't been created yet.
	if ( 'undefined' === typeof window.adTech[ type ] ) {
		window.adTech[ type ] = {
			slots: {}
		};
	}

	// Create the object for the slots to reside.
	if ( typeof window.adTech[ type ].slots === 'undefined' ) {
		window.adTech[ type ].slots = {};
	}

	if ( window.adTech[ type ].slots[ id ] ) {
		window.adTech[ type ].slots[ id ].events = false;
		window.adTech[ type ].slots[ id ].isEmpty = false;
		window.adTech[ type ].slots[ id ].slot = slot;
	} else {
		const index = Object.keys( window.adTech[ type ].slots ).length;

		window.adTech[ type ].slots[ id ] = {
			events: false,
			isEmpty: true,
			sectionIndex,
			type,
			index,
			id,
			slot,
		};
	}

	// Googletag specific key values for the slot.
	if ( 'googletag' === type ) {
		window.adTech[ type ].slots[ id ].destroyed = false;
		window.adTech[ type ].slots[ id ].status_step_1_defined = true;
		window.adTech[ type ].slots[ id ].status_step_2_request = false;
		window.adTech[ type ].slots[ id ].status_step_3_received = false;
		window.adTech[ type ].slots[ id ].status_step_4_rendered = false;
		window.adTech[ type ].slots[ id ].status_step_5_loaded = false;
		window.adTech[ type ].slots[ id ].status_step_6_viewable = false;
	}

	// }, 5000 );
}

export const updateAdSlotValue = ( type, id, key, value ) => {
	// Bail early if the slot was not found.
	if ( 'undefined' === typeof type ||
		'undefined' === typeof window.adTech[ type ] ||
		'undefined' === typeof id ||
		'undefined' === typeof window.adTech[ type ].slots[ id ] ||
		'undefined' === typeof key ||
		'undefined' === typeof window.adTech[ type ].slots[ id ][ key ] ||
		'undefined' === typeof value ) {
		return;
	}

	window.adTech[ type ].slots[ id ][ key ] = value;
}

export const updateAdSlot = ( slot ) => {
	// Bail early if the slot was not found.
	if ( 'undefined' === typeof slot ||
		'undefined' === typeof slot.type ||
		'undefined' === typeof window.adTech[ slot.type ] ||
		'undefined' === typeof slot.id ||
		'undefined' === typeof window.adTech[ slot.type ].slots[ slot.id ] ) {
		return;
	}

	window.adTech[ slot.type ].slots[ slot.id ] = slot;
}

/**
 * Get the slot data for use.
 *
 * @param {string} type
 * @param {string} id The actual id.
 * @param {string} key
 * @returns {undefined|*}
 */
export const getAdSlot = ( type, id, key = null ) => {

	// Bail early if the slot was not found.
	if ( 'undefined' === typeof type ||
		'undefined' === typeof id ||
		'undefined' === typeof window.adTech[ type ] ||
		'undefined' === typeof window.adTech[ type ].slots ||
		'undefined' === typeof window.adTech[ type ].slots[ id ] ) {

		return undefined;
	}

	if ( 'undefined' !== typeof key && key &&
		'undefined' !== typeof window.adTech[ type ].slots[ id ][ key ] ) {

		return window.adTech[ type ].slots[ id ][ key ];
	}

	return window.adTech[ type ].slots[ id ];
}

/**
 * Get the slot data for use.
 *
 * @param {string} type
 * @param {string|null} key
 * @param {string|null} value
 * @returns {undefined|*}
 */
export const getLastAdSlot = ( type, key= null, value = null ) => {

	let slots;

	// Bail early if the slot was not found.
	if ( typeof type === 'undefined' ||
		typeof window.adTech[ type ] === 'undefined' ||
		typeof window.adTech[ type ].slots === 'undefined' ) {

		return;
	}

	if ( typeof key !== 'undefined' &&
		typeof value !== 'undefined' &&
		null !== key &&
		null !== value ) {

		// Get a all slots that match the key value.
		slots = getAdSlots( type, key, value )
	} else {
		// Get all slots.
		slots = window.adTech[ type ].slots;
	}

	if ( ! slots ) {
		return slots;
	}

	const lastSlotIndex = Object.keys( slots ).length - 1;

	// Get the last slot to be added to the queue.
	return Object.values( slots ).reduce( ( obj, slot ) => {
		if ( slot.index === lastSlotIndex ) {
			return slot;
		}
	}, {} );
}

/**
 * Ensure the ad slots are organised by index.
 *
 * @param a
 * @param b
 * @returns {number|number}
 */
const sortAdSlotsByIndex = ( a, b ) => {

	a = a.index;
	b = b.index;

	if ( a === b ) {
		return 0;
	}

	return a < b ? -1 : 1;

}

/**
 * Get the ad slots based on the key or key and value, filtered by value within the slot object.
 *
 * @param {string} type The type of ad slot.
 * @param {string} key The key to compare the value.
 * @param {*} value The value to compare the key.
 *
 * @returns {Array|undefined}
 */
export const getAdSlots = ( type, key = null, value = null ) => {

	// Bail early if the slot was not found.
	if ( typeof type === 'undefined' ||
		typeof window.adTech[ type ] === 'undefined' ||
		typeof window.adTech[ type ].slots === 'undefined' ) {

		return undefined;
	}

	let slots = window.adTech[ type ].slots;

	// Ensure value was passed in.
	if ( 'undefined' === typeof key || 'undefined' === typeof value ) {
		return slots;
	}

	// Process arrays differently.
	if ( Array.isArray( value ) ) {
		slots = Object.values( slots ).filter( slot => value.includes( slot[key] ) ).sort( sortAdSlotsByIndex );
	} else {
		slots = Object.values( slots ).filter( slot => slot[key] === value ).sort( sortAdSlotsByIndex );
	}

	// Filter out the slots that is requested.
	return slots;
}

/**
 * Resolve all of the ad slots requested, waiting the max time in ms for the ads to be stored before not executing.
 *
 * @param {Array} adSlots An array of ad slot ids, or formatted ad slots.
 * @param {Number} maxTimeToWait Max Time to wait.
 * @param {Number} intervalToCheck Time to check.
 *
 * @returns {Promise<Array>}
 */
export const resolveAdSlots = ( adSlots, maxTimeToWait = 2000, intervalToCheck = 50 ) => {

	return new Promise(( resolve, reject ) => {

		let timeLeft = maxTimeToWait,
			adSlotIDsFound = [],
			adSlotsFound = [];

		let interval = setInterval( () => {

			// Loop over the array to check the value for a strings, being the id of the slots.
			for ( let i = 0; i < adSlots.length; i++ ) {


				if ( typeof adSlots[i] === 'string' || adSlots[i] instanceof String ) {
					let adSlotID = adSlots[i];

					if ( adSlotIDsFound.includes( adSlotID ) ) {
						continue;
					}

					// Get the slot if it exists.
					let adSlot = getAdSlot( 'googletag', adSlotID );

					if ( adSlot ) {
						adSlotIDsFound.push( adSlotID );
						adSlotsFound.push( adSlot );
					}
				} else if ( 'undefined' !== typeof adSlots[i].id ) {

					let adSlotID = adSlots[i].id;

					if ( adSlotIDsFound.includes( adSlotID ) ) {
						continue;
					}

					// This is already a formatted slot.
					adSlotIDsFound.push( adSlotID );
					adSlotsFound.push( adSlots[i] );
				}
			}

			if ( adSlotsFound.length === adSlots.length ) {
				// All slots found, proceed.
				clearInterval( interval );
				resolve( adSlotsFound );

			} else if ( timeLeft <= 0 ) {
				// Time ran out.
				adTechLog( {
					type: 'error',
					message: `GoogleTag - slots not found, exceeded the time to wait.`,
					details: {
						adSlots,
						adSlotsFound,
						maxTimeToWait,
					}
				} );

				clearInterval( interval );

				if ( ! adSlotsFound.length ) {
					reject( adSlotsFound );
				} else {
					resolve( adSlotsFound );
				}
			}

			timeLeft -= intervalToCheck;

		}, maxTimeToWait );
	} );
}
